export class UrlParser {
    private static _params: any;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static parseUri() {
        UrlParser._params = {};

        const uri = window.location.search.substr(1);
        const partParams = uri.split('&');

        if (!partParams.length) {
            return;
        }

        partParams.forEach((item) => {
            const [key, value] = item.split('=');
            UrlParser._params[key] = value;
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static getParam(name: string): string {
        if (typeof (UrlParser._params[name]) !== 'undefined') {
            return UrlParser._params[name];
        }

        return null;
    }
}